<template>
  <span>
    <v-chip
      v-if="status === 'success'"
      color="#6CD9D1"
      text-color="white"
    >{{message}}</v-chip>
    <v-chip
      v-if="status === 'failed'"
      color="#E84314"
      text-color="white"
    >
      <v-avatar>
        <v-icon>error_outline</v-icon>
      </v-avatar>{{message}}
    </v-chip>
    <v-chip
      v-if="status === 'error'"
      color="#E84314"
      text-color="white"
    >
      {{message}}
    </v-chip>
    <v-chip
      v-if="status === 'initiated'"
      color="#82BDD9"
      text-color="white"
    >{{message}}</v-chip>
    <v-chip
      v-if="status === 'scheduled'"
      color="#C6C71F"
      text-color="white"
    >
      <v-avatar>
        <v-icon>done</v-icon>
      </v-avatar>{{message}}
    </v-chip>
    <v-chip
      v-if="status === 'triggered'"
      color="#95C124"
      text-color="white"
    >
      <v-avatar>
        <v-icon>check_circle_outline</v-icon>
      </v-avatar>
      {{message}}
    </v-chip>
  </span>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      required: true
    },
    msg: {
      type: String,
      default: ""
    }
  },
  computed: {
    message() {
      return this.msg ? this.msg : this.status;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/status.vue